<bmcore-page-not-found [colorSettingsMode]="colorSettingsMode"> </bmcore-page-not-found>
